/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Auth0UserProfile } from 'auth0-js';

/** Represents a user of the application. */
export interface UserDetails {
  /** The name of the user. */
  name: string;
  /** The picture of the user. */
  picture: string;
  /** The email of the user. */
  email: string;
  /** The roles of the user. */
  roles: string[];
}

/**
 * Builds a UserDetails object given an Auth0UserProfile and a set of user roles
 */
export class UserDetailsFactory {
  /**
   * @param user the Auth0 User Profile
   * @param roles the roles the user has
   * @return a new UserDetails instance
   */
  static userDetails(user: Auth0UserProfile, roles: string[]): UserDetails {
    return {
      name: `${user.given_name} ${user.family_name}`,
      picture: user.picture,
      email: user.email || '',
      roles: roles
    };
  }
}
